import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { JsirLogo } from "../components/Brand";

export default function Signup() {
  const [orgName, setOrgName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const { refresh } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <div className="w-full max-w-sm card p-6">
        <div className="flex flex-col items-center mb-6">
          <JsirLogo className="h-12 w-auto mb-3" />
          <div className="text-xl font-semibold">Create a workspace</div>
          <div className="text-sm text-ink-500">For your church or ministry</div>
        </div>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            setBusy(true); setErr(null);
            try {
              await api.post("/auth/signup", { org_name: orgName, name, email, password });
              await refresh();
              nav("/dashboard");
            } catch (e: any) { setErr(e.message); }
            finally { setBusy(false); }
          }}
          className="space-y-4"
        >
          <div>
            <label className="label">Organisation name</label>
            <input className="input" required autoCapitalize="words" autoComplete="organization" value={orgName} onChange={(e) => setOrgName(e.target.value)} />
          </div>
          <div>
            <label className="label">Your name</label>
            <input className="input" required autoCapitalize="words" autoComplete="name" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div>
            <label className="label">Email</label>
            <input className="input" type="email" inputMode="email" autoComplete="email" autoCapitalize="off" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="label">Password (min 8 chars)</label>
            <input className="input" type="password" autoComplete="new-password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          {err && <div className="text-sm text-brand">{err}</div>}
          <button className="btn-primary w-full" disabled={busy}>{busy ? "Creating…" : "Create workspace"}</button>
        </form>
        <div className="text-sm text-center mt-4 text-ink-500">
          Already have one? <Link to="/login" className="text-brand font-medium">Sign in</Link>
        </div>
      </div>
    </div>
  );
}
